


















import { ArcChartComponent, ArcChartConfig, Params } from '@empathy/insights';

export default {
  name: 'kpi-arc-chart',
  props: {
    kpi: {
      type: Object, // { id: KpiEnum, label: string, valueLabel: string, percentage: number, count: number}
      required: true
    }
  },
  computed: {
    chartParams: function (): Params<ArcChartConfig, number> {
      return {
        config: {
          locale: this.$epb.locale,
          transitionsDurationInMillis: 0
        },
        data: this.kpi.percentage
      };
    },
    countText: function (): string {
      return this.$epb.utils.formatNumber(this.kpi.count, { maximumFractionDigits: 2 }, true);
    }
  },
  data: function () {
    return {
      baseClass: 'epb-kpi-arc-chart',
      chart: undefined
    };
  },
  created: function (): void {
    this.chart = new ArcChartComponent();
  },
  mounted: function (): void {
    this.chart.init(this.$refs.chart, this.chartParams);
  },
  beforeDestroy: function (): void {
    this.chart.destroy();
  },
  watch: {
    chartParams: {
      handler: function (params: Params<ArcChartConfig, number>): void {
        this.chart.update(params);
      },
      deep: true
    }
  }
};

